import { render, staticRenderFns } from "./scene_5.vue?vue&type=template&id=3f5660f2&"
import script from "./scene_5.vue?vue&type=script&lang=ts&"
export * from "./scene_5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports